import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const JobsComponent = ({ tabDataRelationship }) => {
  return (
    <Container relationship={tabDataRelationship} />
  );
};

JobsComponent.propTypes = {
  tabDataRelationship: PropTypes.object.isRequired,
};

export default JobsComponent;
